import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth, initializeUserSession } from './redux/thunks/authThunks';

export default function AuthInitializer() {
    const dispatch = useDispatch();

    useEffect(() => {
        const detectDeviceInfo = async () => {
            let browserName = 'Unknown';
            let browserVersion = 'Unknown';
            let fullBrowserVersion = 'Unknown';
            let platform = 'Unknown';
            let platformVersion = 'Unknown';
            let architecture = 'Unknown';
            let model = 'Unknown';

            if (navigator.userAgentData) {
                const brands = navigator.userAgentData.brands || [];
                const realBrand = brands.find(b => b.brand !== 'Not?A_Brand');

                if (realBrand) {
                    browserName = realBrand.brand;
                    browserVersion = realBrand.version;
                }

                try {
                    const highEntropy = await navigator.userAgentData.getHighEntropyValues([
                        'platform',
                        'platformVersion',
                        'architecture',
                        'model',
                        'uaFullVersion'
                    ]);

                    platform = highEntropy.platform;
                    platformVersion = highEntropy.platformVersion;
                    architecture = highEntropy.architecture;
                    model = highEntropy.model;
                    fullBrowserVersion = highEntropy.uaFullVersion;
                } catch (err) {
                    console.warn("Failed to get high entropy values", err);
                }
            } else {
                // Fallback to userAgent parsing
                const ua = navigator.userAgent;
                if (ua.includes("Edg")) {
                    browserName = "Microsoft Edge";
                    browserVersion = ua.match(/Edg\/([\d.]+)/)?.[1] || '';
                } else if (ua.includes("OPR") || ua.includes("Opera")) {
                    browserName = "Opera";
                    browserVersion = ua.match(/(Opera|OPR)\/([\d.]+)/)?.[2] || '';
                } else if (ua.includes("Chrome")) {
                    browserName = "Google Chrome";
                    browserVersion = ua.match(/Chrome\/([\d.]+)/)?.[1] || '';
                } else if (ua.includes("Firefox")) {
                    browserName = "Mozilla Firefox";
                    browserVersion = ua.match(/Firefox\/([\d.]+)/)?.[1] || '';
                } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
                    browserName = "Safari";
                    browserVersion = ua.match(/Version\/([\d.]+)/)?.[1] || '';
                }

                platform = navigator.platform || 'Unknown';
            }

            // 🔒 Log it or send to backend if neede

            // 👉 Optional: Dispatch to Redux or send to backend
            // dispatch(setDeviceFingerprint({ browserName, platform, ... }));
        };

        detectDeviceInfo();

        // dispatch(fetchCsrfToken());
        // dispatch(checkAuth());
        // dispatch(initializeUserSession());
    }, [dispatch]);

    return null;
}



// import { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { checkAuth, fetchCsrfToken, initializeUserSession } from './redux/thunks/authThunks';


// export default function AuthInitializer() {
//     const dispatch = useDispatch();


//     if (navigator.userAgentData) {
//         const brands = navigator.userAgentData.brands || [];

//         const browserBrand = brands.find(b =>
//             b.brand !== "Not?A_Brand"
//         );

//         console.log("Browser Name:", browserBrand?.brand || "Unknown");
//         console.log("Browser Version:", browserBrand?.version || "Unknown");

//         navigator.userAgentData.getHighEntropyValues([
//             "platform",
//             "platformVersion",
//             "architecture",
//             "model",
//             "uaFullVersion"
//         ]).then(ua => {
//             console.log("Platform:", ua.platform);               // e.g., "Windows"
//             console.log("Platform Version:", ua.platformVersion); // e.g., "11.0.0"
//             console.log("Architecture:", ua.architecture);       // e.g., "x86"
//             console.log("Model:", ua.model);                     // usually empty on desktop
//             console.log("Full Browser Version:", ua.uaFullVersion);
//         });

//     } else {
//         console.log("navigator.userAgentData not supported.");
//     }



//     useEffect(() => {
//         dispatch(fetchCsrfToken());
//         // dispatch(checkAuth());
//         // dispatch(initializeUserSession());
//     }, [dispatch]);

//     return null;
// }
